import React from "react";
import OptionList from "./OptionList";
import { getInterestOptions } from "@components/Discovery/config";

export default function InterestSelection({ subRole, value, onChange }) {
  const options = getInterestOptions(subRole);

  return <OptionList options={options} value={value} onChange={onChange} />;
}
